import Card from 'components/card';
import BuyerMarketPlaceCard from './components/OfferCard';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { CONFIG } from 'variables/config';
import { getImage } from 'variables/images';
import { useNavigate } from 'react-router-dom';
import { allChannels } from 'variables/industries';
import { useIndustries } from 'services/industryService';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import SignUpModal from './components/SignUpModal';
import WelcomeModal from './components/WelcomeModal';

const MySwal = withReactContent(Swal);

const priceOptions = [
    { value: '1-10', label: 'De 1 à 10€' },
    { value: '10-20', label: 'De 10 à 20€' },
    { value: '20-30', label: 'De 20 à 30€' },
    { value: '30-40', label: 'De 30 à 40€' },
    { value: '40-50', label: 'De 40 à 50€' },
    { value: '50-60', label: 'De 50 à 60€' },
    { value: '60-70', label: 'De 60 à 70€' },
    { value: '70-80', label: 'De 70 à 80€' },
    { value: '80-90', label: 'De 80 à 90€' },
    { value: '90-100', label: 'De 90 à 100€' },
    { value: '100+', label: 'Plus de 100€' },
];

const Dashboard = () => {
    const { industries: industriesData, loading: industriesLoading } = useIndustries();
    const [offer, setOffer] = useState([]);
    const [user, setUser] = useState(null);
    const [selectedIndustry, setSelectedIndustry] = useState('');
    const [selectedPrice, setSelectedPrice] = useState('all');
    const [selectedChannel, setSelectedChannel] = useState('all');
    const [isLoading, setIsLoading] = useState(true);
    const [hasInteracted, setHasInteracted] = useState(false);
    const [showSignUpModal, setShowSignUpModal] = useState(false);
    const [showWelcomeModal, setShowWelcomeModal] = useState(false);
    const nav = useNavigate();

    // Guest user detection
    const isGuest = user?.email?.includes('guest-') ?? false;

    const loginGoogle = (token: string) => {
        axios
            .post(`${CONFIG.apiUrl}/auth/google`, { token })
            .then((response: any) => {
                if (response.data.token) {
                    localStorage.setItem('token', response.data.token);
                    localStorage.setItem('user-type', response.data.type);
                    window.location.href = '/admin/dashboard';
                }
            })
            .catch((error: any) => {
                console.log(error);
            });
    };

    const handleGuestInteraction = () => {
        if (
            user &&
            user.email &&
            user.email.includes('guest') &&
            !hasInteracted
        ) {
            setHasInteracted(true);
            openGuestPopUp();
        }
    };

    const initOffer = () => {
        const token = localStorage.getItem('token');
        const config = {
            headers: { Authorization: `Bearer ${token}` },
        };
        axios
            .get(`${CONFIG.apiUrl}/seller-offer/marketplace`, config)
            .then((res) => {
                const offers = res.data;
                setOffer(offers);
                setIsLoading(false);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const getOffersIndustry = () => {
        return industriesData.map(industry => industry.name);
    };

    const updateProfil = async (email: string) => {
        const token = localStorage.getItem('token');
        const config = {
            headers: { Authorization: `Bearer ${token}` },
        };
        const data = { email };
        try {
            const result: any = await axios.put(
                `${CONFIG.apiUrl}/user`,
                data,
                config
            );
            if (result.status === 200) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.error('Error updating profile:', error);
            return false;
        }
    };

    const openGuestPopUp = () => {
        //setShowSignUpModal(true);
        setShowWelcomeModal(true);
    };

    const initUser = () => {
        const token = localStorage.getItem('token');
        const config = {
            headers: { Authorization: `Bearer ${token}` },
        };
        axios
            .get(`${CONFIG.apiUrl}/user/me`, config)
            .then((res) => {
                const user = res.data;
                if (user.kyc_url) {
                    setTimeout(() => {
                        window.location.href = user.kyc_url;
                    }, 3000);
                }
                setUser(user);
            })
            .catch((err) => {
                console.log(err);
                window.location.href = '/auth/sign-in';
            });
    };

    useEffect(() => {
        initOffer();
        initUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const Headline = () => {
        return (
            <div className="rounded-[20px] border border-gray-200/50 bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 p-8 shadow-lg dark:border-white/10 dark:from-navy-800 dark:to-navy-900">
                <div className="flex items-start justify-between gap-8">
                    {/* Left side - Content */}
                    <div className="flex-1">
                        <p className="mb-2 text-xs font-bold uppercase tracking-wider text-leadrs">
                            Leadrs.co
                        </p>
                        <h1 className="mb-4 text-[28px] font-bold leading-tight text-gray-900 dark:text-white">
                            Nos offres 📦
                        </h1>
                        <p className="mb-6 text-base leading-relaxed text-gray-600 dark:text-gray-400">
                            Retrouvez toutes les offres disponibles, explorez
                            les options qui vous intéressent et choisissez
                            celles qui correspondent le mieux à vos besoins.
                        </p>
                        {/* How it works */}
                        <div className="space-y-3">
                            <h3 className="mb-3 flex items-center gap-2 text-sm font-bold text-gray-900 dark:text-white">
                                <span className="text-base">ℹ️</span>
                                Comment ça marche ?
                            </h3>
                            <p className="text-sm text-gray-600 dark:text-gray-400">
                                Leadrs fonctionne comme une boutique en ligne: vous
                                sélectionnez une offre, précisez vos besoins, et
                                recevez des leads qualifiés en temps réel.
                            </p>
                        </div>
                    </div>

                    {/* Right side - Info card */}
                    <div className="w-80 flex-shrink-0">
                        <div className="rounded-[20px] border border-gray-200/50 bg-white p-6 shadow-md dark:border-white/10 dark:bg-navy-800">
                            <div className="mb-4 flex items-center gap-3">
                                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-leadrs/10">
                                    <span className="text-xl">🎯</span>
                                </div>
                                <h3 className="text-base font-bold text-navy-700 dark:text-white">
                                    Offre sur-mesure
                                </h3>
                            </div>
                            <p className="mb-4 text-sm text-gray-600 dark:text-gray-400">
                                Vous ne trouvez pas l'offre qui vous convient ? Créez votre propre offre sur-mesure en quelques clics.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    if (industriesLoading || isLoading) {
        return (
            <div className="flex h-screen items-center justify-center">
                <div className="text-xl font-bold text-navy-700 dark:text-white">
                    {industriesLoading ? 'Chargement des industries...' : 'Chargement...'}
                </div>
            </div>
        );
    }

    return (
        <div className="flex h-full w-full flex-col rounded-[20px] xl:flex-row ">
            <div className="h-full w-full rounded-[20px]">
                {/* left side */}
                <div className="col-span-9 h-full w-full rounded-t-2xl xl:col-span-6">
                    {/* Your Transfers & tables */}
                    <div className="grid w-full grid-cols-12 gap-2">
                        <div className="col-span-12">
                            <div className={'h-full w-full px-1'}>
                                <Headline />
                                <div className="mt-3 gap-3 lg:flex">
                                    {/* Industry filter */}
                                    <div className="col-span-12 mx-2 flex justify-between">
                                        <div>
                                            <select
                                                name="HeadlineAct"
                                                id="HeadlineAct"
                                                onChange={(e: any) => {
                                                    setSelectedIndustry(
                                                        e.target.value
                                                    );
                                                }}
                                                className="mt-1.5 w-full rounded-lg border-gray-300 text-gray-700 sm:text-sm lg:w-[135px]"
                                            >
                                                <option value="">
                                                    Toutes les offres
                                                </option>
                                                {getOffersIndustry().map(
                                                    (industry: any) => (
                                                        <option
                                                            value={industry}
                                                        >
                                                            {industry}
                                                        </option>
                                                    )
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                    {/* Pricing filter */}
                                    <div className="col-span-12 mx-2 flex justify-between">
                                        <div>
                                            <select
                                                name="HeadlineAct"
                                                id="HeadlineAct"
                                                onChange={(e: any) => {
                                                    setSelectedPrice(
                                                        e.target.value
                                                    );
                                                }}
                                                className="mt-1.5 w-full rounded-lg border-gray-300 text-gray-700 sm:text-sm lg:w-[165px]"
                                            >
                                                <option value="all">
                                                    Tous les prix par lead
                                                </option>
                                                {priceOptions.map((option) => (
                                                    <option
                                                        value={option.value}
                                                    >
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    {/* Channel filter */}
                                    <div className="col-span-12 mx-2 flex justify-between">
                                        <div>
                                            <select
                                                name="HeadlineAct"
                                                id="HeadlineAct"
                                                onChange={(e: any) => {
                                                    setSelectedChannel(
                                                        e.target.value
                                                    );
                                                }}
                                                className="mt-1.5 w-full rounded-lg border-gray-300 text-gray-700 sm:text-sm lg:w-[180px]"
                                            >
                                                <option value="all">
                                                    Tous les canaux
                                                    d'acquisition
                                                </option>
                                                {allChannels.map((channel) => (
                                                    <option value={channel}>
                                                        {channel}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                {isLoading ? (
                                    <>
                                        <div className="h-50 mt-[100px] flex items-center justify-center">
                                            <div className="h-12 w-12 animate-spin rounded-full border-b-2 border-t-2 border-leadrs"></div>
                                        </div>
                                        <p className="mt-3 text-center text-leadrs">
                                            Récupération des offres...
                                        </p>
                                    </>
                                ) : (
                                    <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-4">
                                        {user &&
                                            user.role &&
                                            user.role !== 'paying-user' && (
                                                <>
                                                <Card
                                                    extra={`flex flex-col w-full h-full !p-4 3xl:p-![18px] bg-white border-2 border-leadrs border-dashed shadow-xl cursor-pointer`}
                                                >
                                                    <div className="mx-auto my-auto items-center text-center">
                                                        <h1 className="text-2xl font-bold text-leadrs">
                                                            Besoin de
                                                            <br></br>
                                                            nouveaux leads ?
                                                        </h1>
                                                        <button
                                                            className="mx-auto mt-4 flex rounded-2xl bg-leadrs px-5 py-3 text-xs font-bold text-white hover:bg-leadrsLight"
                                                            onClick={() => {
                                                                window.location.href =
                                                                    '/admin/create-order';
                                                            }}
                                                        >
                                                            Faire une commande
                                                        </button>
                                                    </div>
                                                </Card>
                                                <Card
                                                    extra={`flex flex-col w-full h-full !p-4 3xl:p-![18px] bg-white border-2 border-leadrs border-dashed shadow-xl cursor-pointer border-[#10b981]`}
                                                >
                                                    <div className="mx-auto my-auto items-center text-center">
                                                        <h1 className="text-2xl font-bold text-[#10b981]">
                                                            Besoin de
                                                            <br></br>
                                                            nouveaux leads ?
                                                        </h1>
                                                        <button
                                                            className="mx-auto mt-4 flex rounded-2xl bg-[#10b981] px-5 py-3 text-xs font-bold text-white hover:bg-[#10b981]"
                                                            onClick={() => {
                                                                window.location.href =
                                                                    '/admin/create-order';
                                                            }}
                                                        >
                                                            Faire un ordre d'achat
                                                        </button>
                                                    </div>
                                                </Card>
                                                </>
                                            )}
                                        {offer
                                            ?.filter(
                                                (item) =>
                                                    item.industry ===
                                                        selectedIndustry ||
                                                    !selectedIndustry
                                            )
                                            .filter((item) => {
                                                if (selectedPrice === 'all') {
                                                    return true;
                                                }
                                                const [min, max] =
                                                    selectedPrice.split('-');
                                                const price = item.buyerPrice;
                                                if (max) {
                                                    return (
                                                        price >=
                                                            parseInt(min) &&
                                                        price <= parseInt(max)
                                                    );
                                                }
                                                return price >= parseInt(min);
                                            })
                                            .filter((item) => {
                                                if (selectedChannel === 'all') {
                                                    return true;
                                                }
                                                return item.channels.some(
                                                    (channel: string) =>
                                                        channel ===
                                                        selectedChannel
                                                );
                                            })
                                            .slice(0, 3)
                                            .map((item) => (
                                                <BuyerMarketPlaceCard
                                                    channels={item.channels}
                                                    offerNumber={
                                                        item.offerBuyerNumber
                                                    }
                                                    industry={item.industry}
                                                    subIndustry={
                                                        item.subIndustry
                                                    }
                                                    targetPrice={
                                                        item.targetPrice
                                                    }
                                                    weeklyQuantity={Number(
                                                        item.weeklyQuantity
                                                    )}
                                                    leadsGenerated={Number(
                                                        item.leadsGenerated
                                                    )}
                                                    otherIndustry={
                                                        item.otherIndustry
                                                    }
                                                    buyerPrice={item.buyerPrice.toFixed(
                                                        2
                                                    )}
                                                    user={user}
                                                    // status={
                                                    //     user &&
                                                    //     user.role ===
                                                    //         'paying-user'
                                                    //         ? item.status
                                                    //         : 'not-paid'
                                                    // }
                                                    status={item.status}
                                                    image={getImage(
                                                        item.industry,
                                                        item.subIndustry
                                                    )}
                                                    isGuest={isGuest}
                                                    onGuestClick={() => setShowWelcomeModal(true)}
                                                    onClick={() => {
                                                        isGuest ?
                                                            openGuestPopUp() :
                                                            nav(
                                                                `/admin/market-offer/${item._id}`
                                                            );
                                                    }}
                                                />
                                            ))}
                                        {user &&
                                            user.role &&
                                            user.role !== 'user' && (
                                                <Card
                                                    extra={`flex flex-col w-full h-full !p-4 3xl:p-![18px] bg-white border-2 border-leadrs border-dashed shadow-xl cursor-pointer`}
                                                >
                                                    <div className="mx-auto my-auto items-center text-center">
                                                        <h1 className="text-2xl font-bold text-leadrs">
                                                            Besoin de<br></br>
                                                            nouveaux leads ?
                                                        </h1>
                                                        <button
                                                            className="mx-auto mt-4 flex rounded-2xl bg-leadrs px-5 py-3 text-xs font-bold text-white hover:bg-leadrsLight"
                                                            onClick={() => {
                                                                window.location.href =
                                                                    'create-order';
                                                            }}
                                                        >
                                                            Passez commande
                                                        </button>
                                                    </div>
                                                </Card>
                                            )}
                                        {offer
                                            ?.filter(
                                                (item) =>
                                                    item.industry ===
                                                        selectedIndustry ||
                                                    !selectedIndustry
                                            )
                                            .filter((item) => {
                                                if (selectedPrice === 'all') {
                                                    return true;
                                                }
                                                const [min, max] =
                                                    selectedPrice.split('-');
                                                const price = item.buyerPrice;
                                                if (max) {
                                                    return (
                                                        price >=
                                                            parseInt(min) &&
                                                        price <= parseInt(max)
                                                    );
                                                }
                                                return price >= parseInt(min);
                                            })
                                            .filter((item) => {
                                                if (selectedChannel === 'all') {
                                                    return true;
                                                }
                                                return item.channels.some(
                                                    (channel: string) =>
                                                        channel ===
                                                        selectedChannel
                                                );
                                            })
                                            .slice(3)
                                            .map((item) => (
                                                <BuyerMarketPlaceCard
                                                    channels={item.channels}
                                                    offerNumber={
                                                        item.offerBuyerNumber
                                                    }
                                                    industry={item.industry}
                                                    subIndustry={
                                                        item.subIndustry
                                                    }
                                                    targetPrice={
                                                        item.targetPrice
                                                    }
                                                    weeklyQuantity={Number(
                                                        item.weeklyQuantity
                                                    )}
                                                    leadsGenerated={Number(
                                                        item.leadsGenerated
                                                    )}
                                                    otherIndustry={
                                                        item.otherIndustry
                                                    }
                                                    buyerPrice={item.buyerPrice.toFixed(
                                                        2
                                                    )}
                                                    user={user}
                                                    // status={
                                                    //     user &&
                                                    //     user.role ===
                                                    //         'paying-user'
                                                    //         ? item.status
                                                    //         : 'not-paid'
                                                    // }
                                                    status={item.status}
                                                    image={getImage(
                                                        item.industry,
                                                        item.subIndustry
                                                    )}
                                                    isGuest={isGuest}
                                                    onGuestClick={() => setShowSignUpModal(true)}
                                                    onClick={() => {
                                                        nav(
                                                            `/admin/market-offer/${item._id}`
                                                        );
                                                    }}
                                                />
                                            ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <SignUpModal
                isOpen={showSignUpModal}
                onClose={(accountCreated: boolean) => {
                    setShowSignUpModal(false);
                    if (accountCreated) {
                        initUser(); // Refetch user data to reveal prices
                        setShowWelcomeModal(true); // Show welcome modal after successful registration
                    }
                }}
            />
            <WelcomeModal
                isOpen={showWelcomeModal}
                onClose={() => setShowWelcomeModal(false)}
                onSignUp={() => {
                    setShowWelcomeModal(false);
                    setShowSignUpModal(true);
                }}
            />
        </div>
    );
};

export default Dashboard;
